import React, {useContext} from "react";
import { Link } from "react-router-dom";
import {MainContext} from "../../../context/MainContext";

const menuContent = [
  {
    name: {
      "no": "Hjem",
      "en": "Home",
      "mn": "Početna"
    },
    activeClass: "sf-with-ul",
    menuClass: "current-menu-item",
    routerPath: "/"
  },
  {
    name: {
      "no": "Tjenester",
      "en": "Services",
      "mn": "Usluge"
    },
    activeClass: "",
    menuClass: "",
    routerPath: "/services"
  },
  {
    name: {
      "no": "Blogger",
      "en": "Blogs",
      "mn": "Blogovi"
    },
    activeClass: "",
    menuClass: "",
    routerPath: "/blog"
  },
  {
    name: {
      "no": "V\u00e5rt Team",
      "en": "Our Team",
      "mn": "Naš Tim"
    },
    activeClass: "",
    menuClass: "",
    routerPath: "/our-team"
  },
  {
    name: {
      "no": "Kontakt oss",
      "en": "Contact us",
      "mn": "Kontaktirajte nas"
    },
    activeClass: "",
    menuClass: "",
    routerPath: "/contact"
  }
];

const DropdownMenu = () => {
  const { language,  } = useContext(MainContext);

  return (
    <ul className="sf-menu">
      {menuContent.map((item, i) => (
        <li className={`menu-item-has-children ${item.menuClass}`} key={i}>
          <Link to={item.routerPath}>
            {" "}
            <span>{item.name[language]}</span>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default DropdownMenu;
